import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Check, X, Cpu } from 'lucide-react';
import FieldConfidenceBadge from './FieldConfidenceBadge';

export default function AISuggestionPanel({ suggestion, onAccept, onReject }) {
  if (!suggestion || !suggestion.suggestion) return null;

  return (
    <div
      className="mt-1 p-2 bg-slate-50 border border-slate-200 rounded-md space-y-1"
      data-testid={`ai-suggestion-${suggestion.field_key}`}
    >
      <div className="flex items-center gap-2">
        <Cpu className="h-3.5 w-3.5 text-slate-500" />
        <span className="text-xs font-medium text-slate-600">AI Suggested — Verify Before Save</span>
        <Badge variant="outline" className="text-[10px] bg-slate-100 text-slate-600 border-slate-300">
          {suggestion.confidence}
        </Badge>
      </div>

      <p className="text-sm font-mono text-slate-800 pl-5">{typeof suggestion.suggestion === 'object' ? JSON.stringify(suggestion.suggestion) : String(suggestion.suggestion)}</p>

      {suggestion.reason && (
        <p className="text-xs text-slate-400 pl-5 italic">{typeof suggestion.reason === 'object' ? JSON.stringify(suggestion.reason) : String(suggestion.reason)}</p>
      )}

      <div className="flex gap-1 pl-5 pt-1">
        <Button
          size="sm"
          variant="outline"
          className="h-6 text-xs px-2"
          onClick={() => onAccept(suggestion.field_key, suggestion.suggestion)}
          data-testid={`accept-ai-${suggestion.field_key}`}
        >
          <Check className="h-3 w-3 mr-1" />
          Use AI
        </Button>
        <Button
          size="sm"
          variant="ghost"
          className="h-6 text-xs px-2 text-slate-400"
          onClick={() => onReject(suggestion.field_key)}
          data-testid={`reject-ai-${suggestion.field_key}`}
        >
          <X className="h-3 w-3 mr-1" />
          Keep OCR
        </Button>
      </div>
    </div>
  );
}
